import { useCallback, useEffect, useState } from "react";

const KEY = "ssm-reading-progress";
const listeners = new Set<() => void>();

export type ProgressMap = Record<string, string>;

function readProgress(): ProgressMap {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? (parsed as ProgressMap) : {};
  } catch {
    return {};
  }
}

let cache: ProgressMap = readProgress();

function writeProgress(next: ProgressMap) {
  cache = next;
  try {
    localStorage.setItem(KEY, JSON.stringify(next));
  } catch {
    /* ignore storage errors */
  }
  listeners.forEach((listener) => listener());
}

export function useReadingProgress() {
  const [progress, setProgress] = useState<ProgressMap>(cache);

  useEffect(() => {
    const listener = () => setProgress({ ...cache });
    listeners.add(listener);
    listener();
    return () => {
      listeners.delete(listener);
    };
  }, []);

  const saveProgress = useCallback((comicId: string, chapterId: string) => {
    writeProgress({ ...cache, [comicId]: chapterId });
  }, []);

  return { progress, saveProgress };
}